var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeMedia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#changeMedia_svg__clip0_2888_4194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.667 10h16.666M1.667 5.834h4.166m8.334 0h4.166M1.667 14.167h4.166m8.334 0h4.166m-12.5 4.167V1.667m8.334 16.667V1.667m-8.5 16.667h8.666c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 001.093-1.092c.272-.535.272-1.235.272-2.635V5.667c0-1.4 0-2.1-.272-2.635a2.5 2.5 0 00-1.093-1.093c-.534-.272-1.235-.272-2.635-.272H5.667c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 00-1.093 1.093c-.272.535-.272 1.235-.272 2.635v8.667c0 1.4 0 2.1.272 2.635a2.5 2.5 0 001.093 1.092c.534.273 1.235.273 2.635.273z",
    stroke: "#454C52",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "changeMedia_svg__clip0_2888_4194"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgChangeMedia;